
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import InvoiceService from '@/services/invoice.service';
import lazyInject from '@/di';
import { FormModel } from 'ant-design-vue';
import UploadFile from '@/views/operation/components/uploudFile.vue';
import { validateTaxNumber } from '@/common/utils';

@Component({
  components: {
    UploadFile,
  },
})
export default class AddInvoiceModal extends Vue {
  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @Prop({ type: Number, default: 0 })
  kaId!: number;

  @Ref()
  formRef!: FormModel;

  visibleInvoiceModal = false;
  formData: any = {
    title: '',
    tax_no: '',
    address: '',
    tel: '',
    bank: '',
    account: '',
    email: '',
    introduction: '',
    invoice_category: '1',
    buyer_category: '2',
    is_default: '',
    phone: '',
    license: '',
  };
  licenseData: any = {
    id: null,
    url: '',
  };
  title = '新增抬头';
  rules = {
    title: [{ required: true, message: '请输入发票抬头' }],
    tax_no: [{ required: true, validator: this.taxNumberValidator }],
    email: [{ required: true, validator: this.emailValidator }],
    phone: [{ required: true, message: '请输入联系电话' }],
  };

  // 普票
  generalTicket = {
    title: [{ required: true, message: '请输入发票抬头' }],
    tax_no: [{ required: true, validator: this.taxNumberValidator }],
    email: [{ required: true, validator: this.emailValidator }],
    phone: [{ required: true, message: '请输入联系电话' }],

  };
  // 专票
  specialTicket = {
    title: [{ required: true, message: '请输入发票抬头' }],
    tax_no: [{ required: true, validator: this.taxNumberValidator }],
    address: [{ required: true, message: '请输入注册地址' }],
    tel: [{ required: true, message: '请输入注册电话' }],
    bank: [{ required: true, message: '请输入开户银行' }],
    account: [{ required: true, message: '请输入银行账号' }],
    email: [{ required: true, validator: this.emailValidator }],
    phone: [{ required: true, message: '请输入联系电话' }],
    license: [{ required: true, message: '请上传一般纳税人资格证明' }],
  };
  options = [
    { label: '设置为默认抬头', value: '1' },
  ];

  isDefault: any = [];

  type = 'add';

  invoiceId = '';

  emailValidator(rule: any, value: any, callback: any) {
    const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value) {
      callback(new Error('请输入邮箱'));
    } else if (!strictEmailRegex.test(value)) {
      callback(new Error('请输入正确的邮箱地址'));
    } else {
      callback();
    }
  }

  taxNumberValidator(rule: any, value: any, callback: any) {
    if (!value) {
      callback(new Error('请输入税号'));
    } else if (!validateTaxNumber(value)) {
      callback(new Error('请输入正确的税号'));
    } else {
      callback();
    }
  }

  init(row: any, type: string) {
    this.licenseData = [];
    this.isDefault = [];
    this.type = type;
    this.title = type === 'edit' ? '编辑抬头' : '新增抬头';
    this.rules = this.generalTicket;
    if (type === 'edit') {
      const { tax_no, address, tel, bank, account, email, title, license, phone, license_url } = row.info;
      this.invoiceId = row.id;
      this.formData = {
        tax_no,
        address,
        tel,
        bank,
        account,
        email,
        license,
        phone,
        title,
        invoice_category: String(row.invoice_category),
        buyer_category: String(row.category),
        is_default: String(row.is_default),
      };
      if (row.invoice_category == '1') {
        this.rules = this.generalTicket;
      } else {
        this.rules = this.specialTicket;
      }
      if (license) {
        this.licenseData = {
          id: license,
          url: license_url,
        };
      }
      if (this.formData.is_default === '1') {
        this.isDefault = ['1'];
      } else {
        this.isDefault = [];
      }
      // console.log(this.formData, ' this.formData');
    }
    this.visibleInvoiceModal = true;
  }

  changeLicense(val: any) {
    this.licenseData = val;
    this.formData.license = val.id;
  }
  onSubmit() {
    this.formRef.validate((valid) => {
      if (valid) {
        const params = {
          ...this.formData,
          ka_id: this.kaId,
        };
        if (this.isDefault.length > 0) {
          params.is_default = this.isDefault[0];
        } else {
          params.is_default = 0;
        }
        if (this.type === 'edit') {
          this.funEditInvoice(params);
        } else {
          this.funAddInvoice(params);
        }
      } else {
        // console.log('error submit!!');
      }
    });
  }

  onChange(e: any) {
    this.isDefault = e;
  }
  async funAddInvoice(params: any) {
    const res = await this.invoiceService.addInvoiceBuyer(params);
    // console.log(res, ' res');
    if (res) {
      this.$message.success('新增抬头成功');
      this.$emit('refresh');
      this.isDefault = [];
      this.onClose();
    }
  }
  async funEditInvoice(params: any) {
    const res = await this.invoiceService.editInvoiceBuyer(this.invoiceId, params);
    // console.log(res, ' res');
    if (res) {
      this.$message.success('编辑抬头成功');
      this.$emit('refresh');
      this.isDefault = [];
      this.onClose();
    }
  }
  funType(key: string, value: string) {
    if (this.type === 'add') {
      this.formData[key] = value;
      if (key === 'invoice_category') {
        if (value === '1') {
          this.rules = this.generalTicket;
          this.formRef.clearValidate([]);
        } else {
          this.rules = this.specialTicket;
          this.formRef.clearValidate([]);
        }
      }
    }
  }
  onClose() {
    this.visibleInvoiceModal = false;
    this.formRef.resetFields();
    this.formData = {
      title: '',
      tax_no: '',
      address: '',
      tel: '',
      bank: '',
      account: '',
      email: '',
      introduction: '',
      invoice_category: '1',
      buyer_category: '2',
      is_default: '',
      license: '541103',
    };
  }
}
